/**
 * Product Tour API - Backend phase control and completion.
 * Uses POST /discovery/... (same structure as other discovery APIs).
 * Phase: 1=workspace creation, 2=meetings, 3=dashboard, 4=project context,
 *        5=manage requirements, 6=process maps, 7=completion
 */
import httpClient from '../httpClient';

const DISCOVERY_PRODUCT_TOUR_PHASE = '/discovery/product_tour_phase';
const DISCOVERY_USER_PRODUCT_TOUR_COMPLETED = '/discovery/user_product_tour_completed';

const PRODUCT_TOUR_MODE_KEY = 'ids_product_tour_mode';
const PRODUCT_TOUR_WORKSPACE_ID_KEY = 'ids_product_tour_workspace_id';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('ids_token')}`,
  'Content-Type': 'application/json'
});

export function isProductTourMode() {
  return localStorage.getItem(PRODUCT_TOUR_MODE_KEY) === 'true';
}

export function setProductTourMode(active) {
  if (active) {
    localStorage.setItem(PRODUCT_TOUR_MODE_KEY, 'true');
  } else {
    localStorage.removeItem(PRODUCT_TOUR_MODE_KEY);
    localStorage.removeItem(PRODUCT_TOUR_WORKSPACE_ID_KEY);
  }
}

export function getProductTourWorkspaceId() {
  return localStorage.getItem(PRODUCT_TOUR_WORKSPACE_ID_KEY);
}

export function setProductTourWorkspaceId(wsId) {
  if (wsId != null) {
    localStorage.setItem(PRODUCT_TOUR_WORKSPACE_ID_KEY, String(wsId));
  } else {
    localStorage.removeItem(PRODUCT_TOUR_WORKSPACE_ID_KEY);
  }
}

export async function getProductTourPhase() {
  if (!localStorage.getItem('ids_token')) return { status: false, data: { phase: 1 } };
  const res = await httpClient.post(DISCOVERY_PRODUCT_TOUR_PHASE, {}, {
    headers: authHeaders()
  });
  return res?.data || { status: false, data: { phase: 1 } };
}

export async function setProductTourPhase(phase) {
  if (!localStorage.getItem('ids_token')) return { status: false };
  const res = await httpClient.post(DISCOVERY_PRODUCT_TOUR_PHASE, { phase }, {
    headers: authHeaders()
  });
  return res?.data || { status: false };
}

export async function resetProductTourPhase() {
  if (!localStorage.getItem('ids_token')) return { status: false };
  const res = await httpClient.post(DISCOVERY_PRODUCT_TOUR_PHASE, { action: 'reset' }, {
    headers: authHeaders()
  });
  return res?.data || { status: false };
}

export async function setProductTourCompleted(completed) {
  if (!localStorage.getItem('ids_token')) return { status: false };
  const res = await httpClient.post(DISCOVERY_USER_PRODUCT_TOUR_COMPLETED, {
    u_product_tour_completed: completed ? 1 : 0,
  }, {
    headers: authHeaders()
  });
  return res?.data || { status: false };
}
